import React, { useState } from "react";
import NumberFormat from "react-number-format";
import { Icon } from "@cc/react-components";

interface Props {
  defaultPayedAmount: number;
  payedAmount?: number;
  setPayedAmount: (amount: number) => void;
}

const PaymentAmount = ({
  defaultPayedAmount,
  payedAmount,
  setPayedAmount,
}: Props) => {
  const [editing, setEditing] = useState(false);

  const updatePayedAmount = (value: string) => {
    const parsed = parseFloat(value);
    if (!!parsed || parsed === 0) {
      payedAmount = Math.max(0, Math.round(parsed * 100) / 100);
    } else {
      payedAmount = undefined;
    }
  };

  const finishEditingPayedAmount = () => {
    if (!payedAmount || payedAmount === 0) {
      setPayedAmount(defaultPayedAmount);
    } else {
      setPayedAmount(payedAmount);
    }
    setEditing(false);
  };

  return (
    <div onClick={() => setEditing(true)}>
      <NumberFormat
        defaultValue={defaultPayedAmount}
        value={payedAmount ?? defaultPayedAmount}
        isNumericString={true}
        prefix={editing ? "" : "€"}
        decimalSeparator=","
        decimalScale={2}
        fixedDecimalScale={!editing}
        allowNegative={false}
        displayType={editing ? "input" : "text"}
        type="tel"
        inputMode="decimal"
        pattern="\d+[\.,]?\d{0,2}"
        min="0.01"
        step="0.01"
        autoFocus
        onValueChange={(values: any) => updatePayedAmount(values.value)}
        onBlur={finishEditingPayedAmount}
        onKeyDown={(event: any) => {
          if ([9, 13, 27].includes(event.keyCode)) {
            finishEditingPayedAmount();
          }
        }}
        onClick={() => setEditing(true)}
      />
      {!editing && <Icon size="1x" type="edit" />}
    </div>
  );
};

export default PaymentAmount;
